import { getEquipmentType } from "./EquipmentAction";

const dispatchGetEquipmentType = (dispatch: Function) => (assetSubTypeId: number) => {
    dispatch(getEquipmentType(assetSubTypeId));
};

const EquipmentTypeDispatch = {
    dispatchGetEquipmentType
};

export default EquipmentTypeDispatch